var exports = {
  "x": "x112a1f60--f3309b--offer",
  "eh": "x112a1f60--f3309b--room",
  "h_": "x112a1f60--f3309b--description",
  "Wc": "x112a1f60--f3309b--area",
  "q9": "x112a1f60--f3309b--price",
  "O5": "x112a1f60--f3309b--offers",
  "nf": "x112a1f60--f3309b--link",
  "z8": "x112a1f60--f3309b--props-count",
};

module.exports = exports;
